// extracted by mini-css-extract-plugin
export default {"container":"dO-z","topReviewHeading":"eO-z","criticalReview":"fO-z","favorableReview":"gO-z","vsSeparator":"hO-z"};